import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    id?: string
    eyebrow?: string
    title: ReactNode
    description?: ReactNode
    align?: 'left' | 'center'
    tone?: 'dark' | 'light'
    className?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({
    id,
    eyebrow,
    title,
    description,
    align = 'left',
    tone = 'dark',
    className
}): ReactNode => {
    const isDark = tone === 'dark'

    return (
        <div className={cn('max-w-2xl', align === 'center' && 'mx-auto text-center', className)}>
            {eyebrow && (
                <p className={cn('inline-flex items-center gap-3 text-xs font-medium uppercase tracking-[0.28em]', isDark ? 'text-gold' : 'text-gold-light')}>
                    <span aria-hidden='true' className='h-px w-8 bg-current' />
                    {eyebrow}
                </p>
            )}

            <h2 id={id} className={cn('mt-4 text-4xl leading-[1.08] sm:text-5xl', isDark ? 'text-foreground' : 'text-ivory')}>
                {title}
            </h2>

            {description && (
                <p className={cn('mt-5 text-lg leading-relaxed', isDark ? 'text-muted-foreground' : 'text-ivory/75')}>
                    {description}
                </p>
            )}
        </div>
    )
}
